import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MenuItem, TreeNode } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { AppState } from 'src/app/store/app.reducer';
import { BoardUser, BoardUserNode } from 'src/app/model/board-user';
import { Subscription, Observable, Subject, combineLatest, filter } from 'rxjs';
import { BOARD_USERS_DEFAULT_PAGE_SIZE, BOARD_USERS_PAGE_SIZE_OPTIONS } from 'src/app/conf/board-users';
import { EDeviceModel } from 'src/app/conf/device-models';
import { PaginationParams } from 'src/app/model/api/pagination-params';
import { BoardUsersInfo } from 'src/app/model/board-users-info';
import { Command } from 'src/app/model/command';
import { DeviceModel } from 'src/app/model/device-model';
import { DeviceStatus } from 'src/app/model/device-status';
import { BoardUsersTree } from './board-users-tree';
import { selectBoardUserAdded, selectBoardUserEdited, selectBoardUsersItemsPagination, selectBoardUsersTaskRunning, selectCurrentDeviceBoardUsers, selectCurrentDeviceBoardUsersInfo, selectCurrentDeviceFeatures, selectCurrentDeviceModel, selectCurrentDeviceStatus, selectNeedResync, selectPasswordValid } from 'src/app/store/device/device.selector';
import { Lang } from 'src/app/model/lang';
import { selectCurrentLang, selectIsImpersMode, selectRoleExplainedTechnician } from 'src/app/store/user/user.selector';
import { ItemsPagination } from 'src/app/model/api/data-rest';
import { DeviceFeature } from 'src/app/model/device-feature';
import { PasswordDialogComponent } from 'src/app/modules/device/components/password-dialog/password-dialog.component';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-board-users',
	templateUrl: './board-users.component.html',
	providers: [ConfirmationService, DialogService],
})

export class BoardUsersComponent implements OnInit, OnDestroy {
	currentLang$: Observable<Lang | undefined>;
	currentLangSub: Subscription | undefined;
	deviceStatus$: Observable<DeviceStatus | undefined>;
	deviceStatusSub: Subscription | undefined;
	boardUsersLoading$: Observable<boolean | undefined>;
	boardUsersLoadingSub: Subscription | undefined;
	deviceModel$: Observable<DeviceModel | undefined>;
	deviceModelSub: Subscription;
	boardUsers$: Observable<BoardUser[] | undefined>;
	boardUsersSub: Subscription;
	boardUsersInfo$: Observable<BoardUsersInfo | undefined>;
	boardUsersInfoSub: Subscription;
	taskRunning$: Observable<boolean>;
	taskRunningSub: Subscription | undefined;
	paging$: Observable<ItemsPagination | undefined>;
	pagingSub: Subscription;
	boardUserEdited$: Observable<boolean | undefined>;
	boardUserEditedSub: Subscription | undefined;
	boardUserAdded$: Observable<boolean | undefined>;
	boardUserAddedSub: Subscription | undefined;


	deviceFeature$: Observable<DeviceFeature[] | undefined>;
	deviceFeatureSub: Subscription | undefined;
	passwordVerify$: Observable<boolean | undefined>;
	passwordVerifySub: Subscription | undefined;
	isTechnician$: Observable<boolean | undefined>;
	isTechnicianSub: Subscription | undefined;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;
	needResync$: Observable<boolean | undefined>;
	needResyncSub: Subscription | undefined;

	passwordSupport: boolean;
	passwordVerify: boolean;
	isTechnician: boolean;
	isImpersMode: boolean;
	needResync: boolean;

	treeFlattener: any;
	boards: TreeNode[];

	paginatorSub: Subscription;
	// loading: boolean;
	online: boolean;
	configured: number;
	taskRunning: boolean;
	ref: DynamicDialogRef | undefined;

	pageSize = BOARD_USERS_DEFAULT_PAGE_SIZE;
	pageSizeOptions = BOARD_USERS_PAGE_SIZE_OPTIONS;
	paging: PaginationParams = {
		size: BOARD_USERS_DEFAULT_PAGE_SIZE,
		page: 1,
		// sort: BOARD_USERS_DEFAULT_SORT_COLUMN,
		// order: BOARD_USERS_DEFAULT_SORT_COLUMN_DIRECTION,
	};
	resultLength: number;

	deviceModel: DeviceModel;
	deviceStatus: DeviceStatus;
	boardUsers: BoardUser[] = [];
	boardUsersTree: BoardUsersTree;

	boardUsersInfo: BoardUsersInfo;

	buChanged$ = new Subject<boolean>();
	currentDeviceCommands: Command[];
	prevRunning = false;

	items: MenuItem[] | undefined;
	firstToggle : boolean = true;

	loadingMemory = true;

	// Design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
		public dialogService: DialogService
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
		this.deviceModel$ = this.store.select(selectCurrentDeviceModel);
		this.boardUsers$ = this.store.select(selectCurrentDeviceBoardUsers);
		this.boardUsersInfo$ = this.store.select(selectCurrentDeviceBoardUsersInfo);
		this.taskRunning$ = this.store.select(selectBoardUsersTaskRunning);
		this.paging$ = this.store.select(selectBoardUsersItemsPagination);
		this.boardUserEdited$ = this.store.select(selectBoardUserEdited);
		this.boardUserAdded$ = this.store.select(selectBoardUserAdded);
		this.deviceFeature$ = this.store.select(selectCurrentDeviceFeatures);
		this.passwordVerify$ = this.store.select(selectPasswordValid);
		this.isTechnician$ = this.store.select(selectRoleExplainedTechnician);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
		this.needResync$ = this.store.select(selectNeedResync);
	}

	ngOnInit(): void {
		this.getInfo();
		this.currentLangSub = this.currentLang$.subscribe(() => {
			this.getInfo();
		});

		this.deviceStatusSub = this.deviceStatus$.subscribe(deviceStatus => {
			this.deviceStatus = deviceStatus;
			if (this.deviceStatus !== undefined) {
				this.online = deviceStatus.Online;
				this.configured = deviceStatus.Configured;
			}
			// no more accordion Utenti dispositivo -> direct trigger when device is Online
			// we need to check to be on firstToggle for avoid repeated dispatches every time when devicesStatus change
			// devicesStatus change also when you do an action as Open or Close etc
			if (this.online && this.firstToggle) {
				this.toogleOpenPassword();
				this.firstToggle = false;
			}
		});
		this.boardUsersSub = combineLatest([
			this.deviceModel$,
			this.boardUsers$,
		]).subscribe(([deviceModel, boardUsers]) => {
			if (deviceModel) {
				this.deviceModel = deviceModel;
			}
			if (boardUsers) {
				this.boardUsers = boardUsers;
			}
			if (this.deviceModel && this.boardUsers) {
				this.boardUsersTree = new BoardUsersTree(boardUsers, this.deviceModel.BoardClass);
				this.boards = this.boardUsersTree.getNodes();
			}
		});
		this.boardUsersInfoSub = this.boardUsersInfo$.subscribe(boardUsersInfo => {
			this.boardUsersInfo = boardUsersInfo;
			this.loadingMemory = false;
		});
		this.taskRunningSub = this.taskRunning$.subscribe(taskRunning => {
			this.taskRunning = taskRunning;
			if (taskRunning === true) {
				this.getInfo();
				this.prevRunning = true;
			} else {
				if (this.prevRunning) {
					this.reloadBoardUsers();
				}
			}
		});
		this.boardUserAddedSub = this.boardUserAdded$
			.pipe(filter(edit => !!edit))
			.subscribe(() => {
				this.reloadBoardUsers();
				this.getInfo();
			}
			);
		this.boardUserEditedSub = this.boardUserEdited$
			.pipe(filter(edit => !!edit))
			.subscribe(() => {
				this.reloadBoardUsers();
				this.getInfo();
			}
			);
		this.needResyncSub = this.needResync$.subscribe((needResync) => {
			this.needResync = needResync;
		});
		this.deviceFeatureSub = this.deviceFeature$.subscribe(deviceFeatures => {
			const fea = deviceFeatures.find(fe => fe.Name === 'password');
			if (fea !== undefined) {
				this.passwordSupport = true;
			}
		});
		this.passwordVerifySub = this.passwordVerify$.subscribe(passwordVerify => {
			this.passwordVerify = passwordVerify;
			if (this.passwordVerify) {
				this.toogleOpenPassword();
			}
		});
		this.isTechnicianSub = this.isTechnician$.subscribe((isTechnician => {
			this.isTechnician = isTechnician;
		}));
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
		this.setOnPagingChanges();
		// this.addBoardUserMenu(); // -> Don't remove, could be use if you want add in panel header
		this.onResize();
	}

	/* addBoardUserMenu(): void {
		 this.items = [{
			  label: this.translate.instant('MANUAL_ADD'), icon: 'pi cm-configuration',
			  command: () => {
					this.addManualBoardUser();
			  }
		 },
		 {
			  label: this.translate.instant('LOCAL_ACQUIRE'), icon: 'pi cm-reload',
			  command: () => {
					this.addAcquireBoardUser();
			  }
		 }]
	} */

	ngOnDestroy(): void {
		this.deviceStatusSub?.unsubscribe();
		this.boardUsersSub?.unsubscribe();
		this.boardUsersInfoSub?.unsubscribe();
		this.pagingSub?.unsubscribe();
		this.paginatorSub?.unsubscribe();
		this.taskRunningSub?.unsubscribe();
		this.currentLangSub?.unsubscribe();
		this.boardUserEditedSub?.unsubscribe();
		this.boardUserAddedSub?.unsubscribe();
		this.deviceFeatureSub?.unsubscribe();
		this.passwordVerifySub?.unsubscribe();
		this.isTechnicianSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
		this.needResyncSub?.unsubscribe();
	}

	reloadBoardUsers(): void {
		if (this.online) {
			this.paging.size = 100000;
			this.paging.page = 1;
			this.store.dispatch(DeviceActions.getBoardusers({ paging: this.paging }));
		}
	}

	setOnPagingChanges(): void {
		this.pagingSub = this.paging$.pipe(filter(p => !!p))
			.subscribe(
				paging => {
					this.resultLength = paging.TotalCount;
				}
			);
	}

	getInfo(): void {
		if (this.online) {
			this.store.dispatch(DeviceActions.getBoardUsersInfo({}));
		}
	}

	hasChild = (_: number, node: BoardUserNode) => node.expandable;


	isFullMemory(): boolean {
		if (this.boardUsersInfo !== undefined && this.boardUsersInfo.Used >= this.boardUsersInfo.Max) {
			return true;
		}
		return false;
	}

	isRbe4(): boolean {
		return this.deviceModel !== undefined && (this.deviceModel.Id === EDeviceModel.RBE4 || this.deviceModel.Id === EDeviceModel.RBE4030 ||
			this.deviceModel.Id === EDeviceModel.RBE4230 || this.deviceModel.Id === EDeviceModel.GEN_RBE4);
	}
	isRbe24230(): boolean {
		return this.deviceModel !== undefined && (this.deviceModel.Id === EDeviceModel.RBE24230 || this.deviceModel.Id === EDeviceModel.RBE230 ||
			this.deviceModel.Id === EDeviceModel.RBE24 || this.deviceModel.Id === EDeviceModel.GEN_RBE24230);
	}

	toogleOpenPassword(): void {
		if (this.online) {
			if (!this.passwordSupport || this.passwordVerify || (!this.isTechnician && !this.isImpersMode)) {
				this.getInfo();
				this.reloadBoardUsers();
			} else if (this.configured === 0) {
				/* Open Dialog */
				this.ref = this.dialogService.open(PasswordDialogComponent, {
					header: this.translate.instant('PASSWORD'),
					width: '70vw',
					breakpoints: { '1600px': '98vw' },
					contentStyle: { overflow: 'auto' },
				});
			}
		}
	}

	justToogleOpenPassword(): void {
		/* Open Dialog */
		this.ref = this.dialogService.open(PasswordDialogComponent, {
			header: this.translate.instant('PASSWORD'),
			width: '70vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
		});
	}

	isAccess(): boolean {
		if (!this.passwordSupport) {
			return true;
		}
		if (this.passwordVerify) {
			return true;
		}
		if (!this.isTechnician && !this.isImpersMode) {
			return true;
		}
		return false;
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}
}
